import React from 'react'
import { useHistory } from "react-router-dom";
import MovieSearchFormWithRouter from './MovieSearchFormWithRouter';
import MovieSearchFormWithoutRouter from './MovieSearchFormWithoutRouter';


const MovieSearchFormContainer = ({
    textClass='',
    programOverviewUrl='',
    translation, 
    onSubmitSearch= false
    
}) => {
    let history = useHistory()

    if(history) {
        return <MovieSearchFormWithRouter 
            textClass={textClass}
            translation={translation}
            onSubmitSearch={onSubmitSearch}
        />  
    } else if(programOverviewUrl) {
        return <MovieSearchFormWithoutRouter 
            textClass={textClass}
            programOverviewUrl={programOverviewUrl}
            translation={translation}
            onSubmitSearch={onSubmitSearch}
        />
    } else {
        return ''
    }
}

export default MovieSearchFormContainer